const DRAFT_KEY = 'vendor_verification_draft_v1';

export const getTokenExpiry = (token = localStorage.getItem('token')) => {
  if (!token || typeof token !== 'string') return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1] || ''));
    return typeof payload.exp === 'number' ? payload.exp : null;
  } catch {
    return null;
  }
};

/** Seconds until JWT expiry. Negative means already expired. Null if unknown. */
export const getSecondsUntilExpiry = (token) => {
  const exp = getTokenExpiry(token);
  if (exp == null) return null;
  return exp - Math.floor(Date.now() / 1000);
};

export const isSessionExpired = (token, skewSeconds = 15) => {
  const seconds = getSecondsUntilExpiry(token);
  if (seconds == null) return !token;
  return seconds <= skewSeconds;
};

export const isAuthError = (error) => {
  const status = error?.response?.status;
  if (status === 401) return true;
  const message = String(
    error?.response?.data?.message || error?.message || ''
  ).toLowerCase();
  return (
    message.includes('unauthenticated') ||
    (message.includes('token') &&
      (message.includes('expired') || message.includes('invalid'))) ||
    message.includes('session expired')
  );
};

const serializeDocument = (doc) => {
  if (!doc || typeof doc !== 'object') return null;
  return {
    name: doc.name || null,
    url: doc.url || null,
    filename: doc.filename || null,
    size: doc.size || null,
    mime_type: doc.mime_type || null,
  };
};

export const saveVerificationDraft = ({
  formData,
  currentStep,
  selectedOptionalPlatforms,
  timedOut,
}) => {
  try {
    const existing = loadVerificationDraft();
    const payload = {
      savedAt: Date.now(),
      currentStep,
      timedOut: typeof timedOut === 'boolean' ? timedOut : Boolean(existing?.timedOut),
      selectedOptionalPlatforms: selectedOptionalPlatforms || [],
      formData: {
        ...formData,
        business_license: serializeDocument(formData?.business_license),
        insurance_certificate: serializeDocument(formData?.insurance_certificate),
        id_document: serializeDocument(formData?.id_document),
      },
    };
    sessionStorage.setItem(DRAFT_KEY, JSON.stringify(payload));
  } catch {
    // Ignore quota / private mode failures
  }
};

export const markVerificationDraftTimedOut = () => {
  try {
    const existing = loadVerificationDraft();
    if (!existing) return;
    sessionStorage.setItem(
      DRAFT_KEY,
      JSON.stringify({ ...existing, timedOut: true, savedAt: Date.now() })
    );
  } catch {
    // ignore
  }
};

export const loadVerificationDraft = () => {
  try {
    const raw = sessionStorage.getItem(DRAFT_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const clearVerificationDraft = () => {
  try {
    sessionStorage.removeItem(DRAFT_KEY);
  } catch {
    // ignore
  }
};
